import React from 'react';
import { motion } from 'framer-motion';
import { ChefHatIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-20 pb-16 px-6 md:pt-32 md:pb-24 relative overflow-hidden" data-id="element-21">
      <div className="max-w-3xl mx-auto text-center" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex justify-center mb-6" data-id="element-23">
          <div className="bg-cream-dark p-4 rounded-full shadow-warm inline-block" data-id="element-24">
            <ChefHatIcon className="w-10 h-10 text-terracotta" data-id="element-25" />
          </div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-6" data-id="element-26">
          Deja de "trabajar gratis": Domina el Método de Repostería de Guerra y
          crea postres con sabor de{' '}
          <span className="text-5xl md:text-6xl lg:text-7xl text-success" data-id="element-27">
            $5
          </span>{' '}
          USD y un costo de producción de solo{' '}
          <span className="text-5xl md:text-6xl lg:text-7xl text-amber" data-id="element-28">
            $0.50
          </span>
          .
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-terracotta mb-10 font-medium" data-id="element-29">
          El sistema blindado para emprendedores en economías volátiles que
          quieren generar ingresos reales en menos de 72 horas, sin usar
          ingredientes importados ni procesos impagables.
        </motion.h2>

        {/* Kit Image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mb-8" data-id="element-30">
          <img src="https://cdn.magicpatterns.com/uploads/29J5TfoxRo23onfnoPbecg/bono_1.jpg" alt="Kit completo de Repostería de Guerra - Manual, Hoja de Costos y Protocolo de WhatsApp" className="w-full max-w-2xl mx-auto rounded-2xl shadow-warm-lg" data-id="element-31" />
        </motion.div>

        {/* CTA Buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mb-6 space-y-4" data-id="element-32">
          <p className="text-lg md:text-xl font-semibold text-chocolate mb-3" data-id="element-33">
            Adquiere tu guía completa de negocio en casa por solo{' '}
            <span className="text-amber font-bold text-2xl" data-id="element-34">$3.5</span>
          </p>

          <p className="text-sm md:text-base text-chocolate/70 mt-3" data-id="element-35">
            Métodos de pago:{' '}
            <span className="font-medium" data-id="element-36">
              Pago Móvil (tasa oficial BCV euro)
            </span>{' '}
            · <span className="font-medium" data-id="element-37">Binance</span> ·{' '}
            <span className="font-medium" data-id="element-38">Zinli</span>
          </p>

          <CTAButton text="PAGAR CON TARJETA / REGISTRO WEB" className="!py-3 !px-8 !text-lg !md:text-xl" data-id="element-39" />
        </motion.div>

        {/* Urgency Message */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="bg-gradient-to-r from-amber/10 via-terracotta/10 to-amber/10 border-2 border-amber/30 p-6 md:p-8 rounded-2xl mb-10" data-id="element-40">
          <h3 className="text-xl md:text-2xl font-bold text-danger mb-4" data-id="element-41">
            ¡Atención! Esta oferta es por tiempo limitado.
          </h3>
          <div className="space-y-4 text-chocolate/90 text-base md:text-lg" data-id="element-42">
            <p data-id="element-43">
              "He decidido mantener el precio de{' '}
              <span className="font-bold text-amber" data-id="element-44">$3.50</span> para ayudar a
              la mayor cantidad de emprendedores posible a combatir la
              inflación. Sin embargo, los bonos de regalo (la Calculadora y el
              Protocolo de Ventas) solo estarán disponibles para quienes tomen
              acción hoy."
            </p>
            <p className="font-medium text-chocolate-dark" data-id="element-45">
              ¿Por qué esperar? Mañana podrías estar perdiendo dinero nuevamente
              por culpa del "ojímetro". Hoy puedes tener la herramienta exacta
              para blindar tu negocio.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-lg md:text-xl text-chocolate/80 space-y-6 text-left bg-white/50 p-6 md:p-8 rounded-2xl shadow-warm mb-10" data-id="element-46">
          <p data-id="element-47">
            ¿Tienes buena mano para los dulces pero sientes que los ingredientes
            están tan caros que es imposible ganar dinero? Lo vemos a diario:
            gente con talento que hornea con amor, pero que al final de la
            semana se da cuenta de que trabajó gratis porque no supo calcular
            sus costos o usó recetas que no dejan margen de ganancia.
          </p>
          <p data-id="element-48">
            Vender postres en una economía volátil no se trata de hacer alta
            pastelería francesa; se trata de dominar la estrategia de
            "Repostería de Guerra": máxima calidad con insumos locales y una
            ingeniería de costos blindada.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} data-id="element-49">
          <CTAButton href="#pricing" text="COMPRAR AHORA" data-id="element-50" />
        </motion.div>
      </div>
    </section>;
}